<template>
  <v-container fluid class="pa-0">
    <invoice-list v-model="invoices"></invoice-list>
  </v-container>
</template>
<script>
import generalMixin from "@/js/general-mixin";
//import backendService from "@/services/backend-service";
import InvoiceList from "@/components/InvoiceList.vue";
export default {
  name: "InvoiceList",
  mixins: [generalMixin],
  components: { "invoice-list": InvoiceList },
  mounted: function () {
    this.$store.dispatch("getInvoices");
  },
  props: {
    amountReceived: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      //invoices: [],
    };
  },
  computed: {
    invoices: {
      get() {
        return this.$store.getters["invoices"];
      },
      set(val) {
        this.$store.commit("setInvoices", val);
      },
    },
  },
  methods: {},
};
</script>
<style>
.payment-paid {
  background-color: lightgreen;
}
</style>
